import { InjectionToken } from '@angular/core';
import type { Currency } from 'libs/shared-lib/interfaces';

export interface CurrencyNumberConfig {
    country: Uppercase<string>;
    currency: Currency;
    localeReplacement?: {
        [key: string]: string;
    };
    numberSuffixAfterValueAndCurrency?: string[];
    fractionSplitterReplacementLocales?: string[];
    addCurrency: boolean;
    globalSufixTemplate?: string;
}

export const WholesaleCurrencyNumberConfigToken = new InjectionToken<CurrencyNumberConfig>(
    'WholesaleCurrencyNumberConfigToken',
);

export function provideWholesaleCurrencyNumberConfig(config: CurrencyNumberConfig) {
    return {
        provide: WholesaleCurrencyNumberConfigToken,
        useValue: config,
    };
}
